/** Deterministic on-brand gradient for shows without uploaded artwork yet. */
function hash(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) h = (h * 31 + seed.charCodeAt(i)) | 0;
  return Math.abs(h);
}

/** Blue-family gradient derived from a seed (stays within the black & blue palette). */
export function posterGradient(seed: string): string {
  const h = hash(seed);
  const a = 200 + (h % 35); // 200–235: cyan → blue
  const b = 215 + ((h >> 3) % 30);
  return `linear-gradient(150deg, hsl(${a} 70% 38%), hsl(${b} 75% 16%))`;
}
